import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Regions } from '../models/legacy';
import { SpinnerService } from '../shared-new/services/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public baseUrlRepo = environment.api2BaseUrl;
  public onError: BehaviorSubject<string> = new BehaviorSubject('');

  public serviceParameter = {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    Authorization: ''
  };

  public constructor(private readonly http: HttpClient, private spinnerService: SpinnerService) { } // Inject SpinnerService

  public getRegions(): Observable<Regions[]> {
    this.spinnerService.addRequest('getRegions'); // Show spinner
    return this.http.get<Regions[]>(`${this.baseUrlRepo}/api/lookups/regions`).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      finalize(() => this.spinnerService.popRequest('getRegions')) // Hide spinner on completion
    );
  }

  public pauseFileUploading(fileId: string): Observable<boolean> {
    const chunkId = fileId.split('_')[0];
    this.spinnerService.addRequest('pauseFileUploading'); // Show spinner
    return this.http.delete<boolean>(`${this.baseUrlRepo}/api/StudyFiles/${chunkId}/pause`).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      finalize(() => this.spinnerService.popRequest('pauseFileUploading')) // Hide spinner on completion
    );
  }

  public resumeFileUploading(fileId: string): Observable<boolean> {
    const chunkId = fileId.split('_')[0];
   this.spinnerService.addRequest('resumeFileUploading'); // Show spinner
    return this.http.delete<boolean>(`${this.baseUrlRepo}/api/StudyFiles/${chunkId}/resume`).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      finalize(() => this.spinnerService.popRequest('resumeFileUploading')) // Hide spinner on completion
    );
  }

  public cancelFileUploading(fileId: string): Observable<boolean> {
    const chunkId = fileId.split('_')[0];
    this.spinnerService.addRequest('cancelFileUploading'); // Show spinner
    return this.http.delete<boolean>(`${this.baseUrlRepo}/api/StudyFiles/${chunkId}/cancel`).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      finalize(() => this.spinnerService.popRequest('cancelFileUploading')) // Hide spinner on completion
    );
  }

  public getCountries(): Observable<HttpResponse<JSON>> {
    this.spinnerService.addRequest('getCountries'); // Show spinner
    return this.http
      .get<JSON>(`${this.baseUrlRepo}/api/lookups/countries`, {
        withCredentials: false,
        observe: 'response',
        headers: this.serviceParameter
      })
      .pipe(
        catchError((error: Error) => {
          this.onError.next(error.message);
          return throwError(error);
        }),
        finalize(() => this.spinnerService.popRequest('getCountries')) // Hide spinner on completion
      );
  }
}
